import React from "react"
import Svg from "../_svgs/svg"

const TeaserMessageCard = ({ link, linkText, icon, heading, invertedCard }) => {
  return (
    <a className={`store-item message-card${invertedCard ? " inverted" : ""}`} href={link ? link : undefined}>
      <div className="content">
        {icon ? (
          <div className={`icon`}>
            <Svg iconName={icon} fillColor={"transparent"} />
          </div>
        ) : (
          ""
        )}
        <div className="imgtext">
          <h3 className="header" data-epi-edit="Heading">
            {heading || "Heading"}
          </h3>
          <span className="linktext" data-epi-edit="LinkText">
            {linkText || "Link Text"}
          </span>
        </div>
      </div>
    </a>
  )
}

export default TeaserMessageCard
